// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__2kmuM","actions":"GroupTable_actions__Ylvmq","deleteModalFooter":"GroupTable_deleteModalFooter__3XdTC"};